import { useSearchParams } from 'react-router-dom';

type UseRequiredSearchParamsResult<T extends string> = {
  params: Record<T, string>;
  isValid: boolean;
};

export const useRequiredSearchParams = <T extends string>(
  keys: readonly T[]
): UseRequiredSearchParamsResult<T> => {
  const [searchParams] = useSearchParams();

  const params = {} as Record<T, string>;
  let isValid = true;

  for (const key of keys) {
    const value = searchParams.get(key)?.trim();
    if (!value) {
      isValid = false;
    } else {
      params[key] = value.toLowerCase();
    }
  }

  return { params, isValid };
};
